module.exports = __webpack_public_path__ + "media/views/about/images/icons/faq_5-3bbe5a94cdeaf5e4922237ad90ca09a0.svg";